// extracted by mini-css-extract-plugin
export default {"path":"Underline_path__8A3Zk"};